import type { SyntheticEvent } from "react";

export const fallbackIconSrc =
  "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLWZpbGUtcXVlc3Rpb24tbWFyayIgYXJpYS1oaWRkZW49InRydWUiPjxwYXRoIGQ9Ik02IDIyYTIgMiAwIDAgMS0yLTJWNGEyIDIgMCAwIDEgMi0yaDhhMi40IDIuNCAwIDAgMSAxLjcwNC43MDZsMy41ODggMy41ODhBMi40IDIuNCAwIDAgMSAyMCA4djEyYTIgMiAwIDAgMS0yIDJ6Ij48L3BhdGg+PHBhdGggZD0iTTEyIDE3aC4wMSI+PC9wYXRoPjxwYXRoIGQ9Ik05LjEgOWEzIDMgMCAwIDEgNS44MiAxYzAgMi0zIDMtMyAzIj48L3BhdGg+PC9zdmc+";

export function resolveIconSrc(icon: string | null | undefined): string {
  return icon?.trim() || fallbackIconSrc;
}

const SVG_DATA_URL = /^data:image\/svg\+xml(?<params>[^,]*),(?<payload>[\s\S]*)$/;

/**
 * True when the icon is an SVG data URL that paints with `currentColor`. The
 * chrome renders such a glyph through a CSS mask so it inherits the CSS
 * `color` in effect — the sidebar text colours and their hover, active, and
 * muted states. Everything else — SVGs with their own
 * colours, artwork, raster images, remote URLs — reports false and keeps the
 * plain <img> rendering unchanged.
 */
export function iconUsesCurrentColor(icon: string | null | undefined): boolean {
  const match = SVG_DATA_URL.exec(icon?.trim() ?? "");
  if (!match?.groups) {
    return false;
  }

  const { params, payload } = match.groups;
  try {
    const svg = params.split(";").includes("base64") ? atob(payload) : decodeURIComponent(payload);
    return svg.includes("currentColor");
  } catch {
    // Undecodable payloads render as-is through <img>, like any other icon.
    return false;
  }
}

/** Replaces an unavailable registry icon with a deterministic, decorative fallback. */
export function handleIconImageError(event: SyntheticEvent<HTMLImageElement>): void {
  const image = event.currentTarget;
  image.onerror = null;
  image.src = fallbackIconSrc;
}
